<div class="content-rail">
  <ng-leaf-loading-spinner
    size="large"
    class="loader"
  ></ng-leaf-loading-spinner>
  <div class="cdsso-content">
    <h3>Redirecting...</h3>
    <p>You are being logged in to the CHCP site.</p>
  </div>
</div>
